exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 992px) {\r\n  .vertical_center_col {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n  }\r\n}\r\n\r\n.vertical_center_col{\r\n  text-align: center;\r\n  margin:0 auto;\r\n}\r\n\r\n.last_col{\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.image_center{\r\n  max-width: 50%;\r\n  margin:0 auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/pages/quotation/draw-lego/draw-lego.component.css
// module id = ../../../../../src/app/pages/quotation/draw-lego/draw-lego.component.css
// module chunks = main